import React, { createRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { connect } from 'react-redux';
import {
    NewGroup,
    Settings,
    ArrowBack,
    ClosePopup,
    Logout,
    HikeLogoSmall,
    DotMenu,
    NewChat,
} from '../../assets/images';
import WebChatLogout from '../WebChat/Authentication/WebChatLogout';
import WebChatPopup from '../WebChat/Authentication/WebChatPopup';
import ActionPopUp from '../WebChat/ContactInfo/ActionPopUp';
import ParticipantPopUp from '../WebChat/ContactInfo/ParticipantsPopUp';
import CreateNewGroup from '../WebChat/NewGroup';
import RecentChatSection from '../WebChat/RecentChat';
import CallParticipantsPopup from '../WebCall/ParticipantsPopUp';
import WebChatCallLogs from '../WebCall/CallLogs/WebCallLogs';
import Setting from '../WebChat/Setting';
import WebChatRoster from '../WebChat/WebChatRoster';
import WebChatVCard from '../WebChat/WebChatVCard/WebChatVCard';
import MediaErrorPopup from '../WebCall/MediaErrorPopup';
import CallConversionPopup from '../WebCall/CallConversionPopup';
import callLogsObj from '../WebCall/CallLogs/callLog';
import { fetchingCallLog } from '../../Actions/CallLogAction';
import Store from '../../Store';
import {
    CALL_CONVERSION_STATUS_ACCEPT,
    CALL_CONVERSION_STATUS_CANCEL,
    CALL_CONVERSION_STATUS_DECLINE,
    CALL_CONVERSION_STATUS_REQUEST,
    CALL_CONVERSION_STATUS_REQ_WAITING,
} from '../../Helpers/Call/Constant';
import { Archived } from '../WebChat/Setting/images';
import { UpdateArchiveChatDataAction } from '../../Actions/Common';
import Modal from '../WebChat/Common/Modal';
import ActionPopup from '../ActionPopup/index';
import { showModal } from '../../Actions/PopUp';
import { disconnectCallConnection } from '../../Helpers/Call/Call';
import { callIntermediateScreen, resetConferencePopup } from '../../Actions/CallAction';
import { NEW_CHAT_CONTACT_PERMISSION_DENIED, NEW_GROUP_CONTACT_PERMISSION_DENIED } from '../../Helpers/Chat/Constant';
import { encryptAndStoreInLocalStorage } from '../WebChat/WebChatEncryptDecrypt';
import userList from '../WebChat/RecentChat/userList';
import { REACT_APP_CONTACT_SYNC } from '../processENV';
import Channels from '../../channels';
import Invitiations from '../../channels/Invitiations';
import { setTabActiveStatus } from '../../channels/utils';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
// icons
import { ReactComponent as MessageSquareChat } from '../../assets/images/sidenav/icons/message-square-chat.svg';
import { ReactComponent as MessageSquareChatFilled } from '../../assets/images/sidenav/filled-icons/message-square-chat-filled.svg';
import { ReactComponent as Phone } from '../../assets/images/sidenav/icons/phone.svg';
import { ReactComponent as PhoneFilled } from '../../assets/images/sidenav/filled-icons/phone-filled.svg';
import { ReactComponent as Gear } from '../../assets/images/sidenav/icons/gear.svg';
import { ReactComponent as GearFilled } from '../../assets/images/sidenav/filled-icons/gear-filled.svg';
import { ReactComponent as MessageSquarePlus } from '../../assets/images/chat-header/message-square-plus.svg';
import { ReactComponent as NewLogo } from '../../assets/images/new-images/appicon.svg';

import { resetWallpaperColor, wallpaperPreviewSection } from '../../Actions/WallpaperActions';
import ProfileImage from '../WebChat/Common/ProfileImage';
import { useSelector } from 'react-redux';
import { formatUserIdToJid } from '../../Helpers/Chat/User';
import { requestCall } from '../../Slice/commonSlice';
import { CALL_TYPE } from '../../features/calls/constants';
import CallScheduling from '../WebChat/ContactInfo/CallScheduling';
import Button from '../../ui/Button';

export const navigateChannel = createRef(null);

const sidenavIcons = {
    messageSquareChat: {
        default: <MessageSquareChat className="side-nav-icon" />,
        filled: <MessageSquareChatFilled className="side-nav-icon" />,
    },
    phone: {
        default: <Phone className="side-nav-icon" />,
        filled: <PhoneFilled className="side-nav-icon" />,
    },
    gear: {
        default: <Gear className="side-nav-icon" />,
        filled: <GearFilled className="side-nav-icon" />,
    },
};

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.currentUserRequestingCallSwitch = false;
        this.remoteUserRequestingCallSwitch = false;
        this.menuRef = React.createRef();
        this.state = {
            menuDropDownStatus: false,
            popupStatus: false,
            newChatStatus: true,
            newChatStatusLevel: '',
            newGroupParticipants: false,
            archivedChatList: false,
            menuSetGroupImage: false,
            chatLogs: false,
            handleBackStatus: false,
            callLogs: false,
            settingStatus: false,
            archivedSetting: false,
            callLogCount: 1,
            scheduleMeetData: null,
            channelsStatus: false,
            invitationsStatus: false,
            webChatRosterStatus: false,
            showProfilePageNew: false,
            setMenuActiveStatus: 0,
            // tempActiveIndex: null,
            selectedMenuName: 'Chats',
            newCall: false,
            newCallType: '',
        };
    }

    handleLogutStatus = status => {
        this.setState({ popupStatus: status, menuDropDownStatus: false });
    };

    handleMenuIconActiveStatus = index => {
        // this.setState({ setMenuActiveStatus: index, tempActiveIndex: null });
        //preview section close
        this.props.wallpaperPreviewSection(false);
        switch (index) {
            case 0:
                this.setState({ selectedMenuName: 'Chats', showProfilePageNew: false, archivedChatList: false });
                if (this.state.callLogs) {
                    this.handleBackFromCallLogs(true);
                } else if (this.state.settingStatus) {
                    this.handleBackFromSetting();
                } else if (this.state.channelsStatus) {
                    this.handleChannelsClick(false);
                } else if (!this.state.newChatStatus) {
                    this.setState({ newChatStatus: true });
                }
                break;
            // case 1:
            //   this.setState({ selectedMenuName: "Channels" });
            //   this.handleChannelsClick();
            //   if (this.state.callLogs) {
            //     this.handleChannelsClick(true);
            //   }
            //   else if (this.state.settingStatus) {
            //     this.handleBackFromSetting();
            //   }
            //   break;
            case 1:
                this.setState({ selectedMenuName: 'Call Logs', showProfilePageNew: false, archivedChatList: false });
                this.handleCallLogs();
                if (this.state.settingStatus) {
                    this.handleBackFromSetting();
                }
                break;
            case 2:
                this.setState({ selectedMenuName: 'Settings', showProfilePageNew: false, archivedChatList: false });
                this.handleSetting();
                if (this.state.callLogs) {
                    this.handleBackFromCallLogs(true);
                } else if (this.state.channelsStatus) {
                    this.handleBackFromCallLogs(true);
                }
                break;
            default:
                break;
        }
        this.setState({ setMenuActiveStatus: index });
        Store.dispatch(setTabActiveStatus(index));
    };

    handleNewCallNavigation = type => {
        if (!REACT_APP_CONTACT_SYNC) {
            userList.getUsersListFromSDK(1);
        }
        this.setState({
            newGroupParticipants: true,
            newCall: true,
            newCallType: type,
            menuDropDownStatus: false,
            callLogs: false,
        });
    };

    handleBackFromNewCall = () => {
        this.setState({
            newGroupParticipants: false,
            newCall: false,
            newCallType: '',
            callLogs: true,
        });
    };

    handleMakeNewCall = (type, participants) => {
        if (!participants || participants.length === 0) return;

        const isVideoCall = type === 'video';
        const userIds = participants.map(p => p.userId);
        const maxUsers = parseInt(process.env.REACT_APP_MAX_USERS_CALL) || 4;

        if (userIds.length > maxUsers - 1) {
            toast.error(`Maximum ${maxUsers} members allowed in a call`);
            return;
        }

        if (userIds.length === 1) {
            this.props.requestCall({
                userId: userIds[0],
                callType: isVideoCall ? CALL_TYPE.VIDEO : CALL_TYPE.AUDIO,
            });
        } else {
            this.props.requestCall({
                userIds: userIds,
                groupId: null,
                callType: isVideoCall ? CALL_TYPE.VIDEO : CALL_TYPE.AUDIO,
                isGroup: true,
            });
        }

        this.handleBackFromNewCall();
    };

    // handleSidebarUlMouseEnter = () => {
    //   this.setState({ tempActiveIndex: this.state.setMenuActiveStatus, setMenuActiveStatus: null });
    // };

    // handleSidebarUlMouseLeave = () => {
    //   if (this.state.tempActiveIndex !== null) {
    //     this.setState({ setMenuActiveStatus: this.state.tempActiveIndex, tempActiveIndex: null });
    //   }
    // };

    handleMenuDrop = e => {
        e.stopPropagation();
        this.setState(prevState => ({
            menuDropDownStatus: !prevState.menuDropDownStatus,
        }));
    };

    outsidePopupClick = e => {
        const { popUpData: { modalProps: { open } = {} } = {} } = this.props;

        if (open) return;

        if (this.menuRef.current && !this.menuRef.current.contains(e.target)) {
            this.setState({ menuDropDownStatus: false, popupStatus: false });
        }
    };

    handleNewChat = () => {
        if (this.props.contactPermission === 0) {
            this.props.handleContactPermissionPopup(true, NEW_CHAT_CONTACT_PERMISSION_DENIED);
            return;
        }
        // Always refetch the full roster on opening New Chat: prior searches in this
        // panel call getUsersListFromSDK with a search term, which replaces rosterData
        // with only the matches. Without an unconditional refresh, any path that exits
        // and reopens (contact click, back arrow, call/settings detour) can land on a
        // filtered list with an empty search bar.
        if (!REACT_APP_CONTACT_SYNC) {
            userList.getUsersListFromSDK(1, '', 5000);
        }
        this.setState({ newChatStatus: false, callLogs: false });
    };

    loadInitialUsersIfNeeded = () => {
        if (REACT_APP_CONTACT_SYNC) return;
        const { rosterData: { data = [] } = {} } = Store.getState() || {};
        const hasFriends = Array.isArray(data) && data.some(u => u.isFriend);
        if (!hasFriends) {
            userList.getUsersListFromSDK(1, '', 5000);
        }
    };

    handleCallLogs = () => {
        this.setState({
            newChatStatus: false,
            callLogs: true,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            invitationsStatus: false,
            channelsStatus: false,
            webChatRosterStatus: false,
        });
        const { callLogData } = this.props;
        const hasCallLogs = Object.keys(callLogData.callLogs || {}).length > 0;
        if (!hasCallLogs && !callLogData.isFetchingCallLog) {
            Store.dispatch(fetchingCallLog(true));
            callLogsObj.getCallLogsFromServer(1);
        }
    };

    handleChatsClick = () => {
        this.props.handlePopupState(true);
        let statusView = 'block';
        this.props.handleConversationSectionDisplay(statusView);
        this.setState({
            newChatStatus: true,
            callLogs: false,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            invitationsStatus: false,
            channelsStatus: false,
            webChatRosterStatus: false,
        });
    };

    handleChannelsClick = (channelsStatus = true) => {
        this.setState({
            channelsStatus,
            invitationsStatus: false,
            newChatStatus: !channelsStatus,
            callLogs: false,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            webChatRosterStatus: false,
        });
    };
    handleInvitationsClick = () => {
        this.setState({
            invitationsStatus: true,
            channelsStatus: false,
            newChatStatus: false,
            callLogs: false,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            webChatRosterStatus: false,
        });
    };

    /**
     * handleBackStatus() manage view of recent chat or conversatipon page in responsive mode.
     * Also manage view of recent chat or roster.
     */
    handleBackStatus = status => {
        this.props.handlePopupState(status);
        let statusView = 'block';
        this.setState({ newChatStatus: status }, () => {
            this.props.handleConversationSectionDisplay(statusView);
        });
    };

    handleDropdownStatus = status => {
        this.setState({ menuDropDownStatus: !this.state.menuDropDownStatus });
    };

    //New group participant list
    handleCreateNewGroup = () => {
        if (this.props.contactPermission === 0) {
            this.props.handleContactPermissionPopup(true, NEW_GROUP_CONTACT_PERMISSION_DENIED);
            return;
        }
        this.loadInitialUsersIfNeeded();
        this.setState({ newGroupParticipants: true, newCall: false, newCallType: '' }, () => {
            this.setState({ menuDropDownStatus: false });
        });
    };

    handleArchivedChatList = () => {
        this.setState({ archivedChatList: true, menuDropDownStatus: false, callLogs: false }, () => {
            setTimeout(() => {
                Store.dispatch(UpdateArchiveChatDataAction({ isArchived: true }));
            }, 1000);
        });
    };

    handleBackToRecentChat = () => {
        this.setState(
            {
                newGroupParticipants: false,
                archivedChatList: false,
            },
            () => {
                Store.dispatch(UpdateArchiveChatDataAction({ isArchived: false }));
            },
        );
    };
    handleBackToRecentChatFromInvite = () => {
        this.setState(
            {
                newGroupParticipants: false,
                archivedChatList: false,
                invitationsStatus: false,
                newChatStatus: false,
                channelsStatus: false,
                newChatStatus: true,
                menuDropDownStatus: false,
            },
            () => {
                Store.dispatch(UpdateArchiveChatDataAction({ isArchived: false }));
            },
        );
    };

    handleSetting = () => {
        this.setState({
            settingStatus: true,
        });
    };
    handleBackFromSetting = () => {
        this.setState({
            settingStatus: false,
        });
    };
    handleBackFromCallLogs = status => {
        this.setState({ newChatStatus: status });
        this.setState({ callLogs: false });
        this.setState({ channelsStatus: false });
        this.setState({ selectedMenuName: 'Chats' });
    };

    _sideMenuPop = () => {
        return (
            <>
                <OutsideClickHandler onOutsideClick={() => this.outsidePopupClick()}>
                    {this.state.menuDropDownStatus && (
                        <ul className="menu-dropdown">
                            <li title="New Group" onClick={this.handleCreateNewGroup}>
                                <i>
                                    <NewGroup />
                                </i>
                                <span>New Group</span>
                            </li>
                            {/* <li title="Starred Messages" onClick={this.handleStarred} ><i><Starred/></i><span>Starred</span></li>  */}
                            <li title="Settings" onClick={this.handleSetting}>
                                <i>
                                    <Settings />
                                </i>
                                <span>Settings</span>
                            </li>
                            <WebChatLogout
                                history={this.props.history}
                                logoutStatus={this.handleLogutStatus}
                                handleDropdownStatus={this.handleDropdownStatus}
                            />
                        </ul>
                    )}
                </OutsideClickHandler>
            </>
        );
    };

    browserNotifyRedirect = prevProps => {
        // When click on missed call notification, need to redirect to calllog page
        // We check the browserNotify pageName is 'calllog', then swith the page to calllog
        const prevPropsBrowserNotifyData = prevProps.browserNotifyData;
        const browserNotifyData = this.props.browserNotifyData;
        if (
            browserNotifyData.pageName &&
            prevPropsBrowserNotifyData.pageName !== browserNotifyData.pageName &&
            browserNotifyData.pageName === 'calllog'
        ) {
            this.handleCallLogs();
        }
    };
    handleClickOutside = event => {
        if (
            this.menuRef.current &&
            !this.menuRef.current.contains(event.target) &&
            !event.target.closest('.menu-icon')
        ) {
            this.setState({ menuDropDownStatus: false });
        }
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate = prevProps => {
        this.browserNotifyRedirect(prevProps);
    };

    resetCallConversionRequestData = () => {
        this.currentUserRequestingCallSwitch = false;
        this.remoteUserRequestingCallSwitch = false;
    };

    renderRecentChat = pageType => {
        return (
            <RecentChatSection
                pageType={pageType}
                handleConversationSectionDisplay={this.props.handleConversationSectionDisplay}
                handleBackStatus={this.handleBackStatus}
                callUserJID={this.props.callUserJID}
                callStatus={this.props.callStatus}
                newChatStatus={this.state.newChatStatus}
                handleShowCallScreen={this.props.handleShowCallScreen}
                callType={this.props.callType}
                callMode={this.props.callMode}
                handlePopupState={this.props.handlePopupState}
                handleArchivedChatList={this.handleArchivedChatList}
            />
        );
    };

    closeModel = modelType => {
        Store.dispatch(
            showModal({
                open: false,
                modelType,
            }),
        );
    };

    handleJoinCallAction = () => {
        encryptAndStoreInLocalStorage('isNewCallExist', true);
        disconnectCallConnection();
        Store.dispatch(resetConferencePopup());
        this.closeModel('CallConfirm');
        const newLink = this.props.popUpData?.modalProps?.newCallLink;
        setTimeout(() => {
            Store.dispatch(callIntermediateScreen({ show: true, link: newLink }));
        }, 10);
    };

    handleCancel = () => {
        this.closeModel('CallConfirm');
    };

    handleMeetMsgeSend = scheduleMeetData => {
        this.props.handleMeetMsgeSend(scheduleMeetData);
    };

    render() {
        let {
            menuDropDownStatus,
            popupStatus,
            newChatStatus,
            newGroupParticipants,
            settingStatus,
            callLogs,
            archivedChatList,
            callLogCount,
            channelsStatus,
            invitationsStatus,
            setMenuActiveStatus,
            selectedMenuName,
            showProfilePageNew,
            options,
            svgs,
        } = this.state;

        const {
            vCardData,
            popUpData: {
                modalProps: { open, modelType },
            },
            callConversionData,
            featureStateData,
        } = this.props;
        navigateChannel.current = {
            toInvitations: this.handleInvitationsClick,
            toRecentChannels: this.handleChannelsClick,
            toChats: this.handleChatsClick,
            toCallLogs: this.handleCallLogs,
            toSettings: this.handleSetting,
        };
        const {
            isOneToOneCallEnabled = false,
            isGroupCallEnabled = false,
            isGroupChatEnabled = false,
        } = featureStateData;
        if (callConversionData && callConversionData.status) {
            if (callConversionData.status === CALL_CONVERSION_STATUS_ACCEPT) {
                if (this.remoteUserRequestingCallSwitch === true && this.currentUserRequestingCallSwitch === true) {
                    this.currentUserRequestingCallSwitch = false;
                }
                this.remoteUserRequestingCallSwitch = false;
            } else if (callConversionData.status === CALL_CONVERSION_STATUS_REQ_WAITING) {
                this.currentUserRequestingCallSwitch = true;
            } else if (callConversionData.status === CALL_CONVERSION_STATUS_REQUEST) {
                this.remoteUserRequestingCallSwitch = true;
            } else if (callConversionData.status === CALL_CONVERSION_STATUS_CANCEL || CALL_CONVERSION_STATUS_DECLINE) {
                this.resetCallConversionRequestData();
            }
        }

        return (
            <>
                {/* <LeftMenuNavigation
                    state={this.state}
                    onCallsLogClick={this.handleCallLogs}
                    onClickChats={this.handleChatsClick}
                    onClickSettings={this.handleSetting}
                    onChannelsClick={this.handleChannelsClick}
                    onInvitationsClick={this.handleInvitationsClick}
                /> */}
                <nav className={`sidebar_menu ${showProfilePageNew ? 'showProfilePage' : ''}`}>
                    <div className="sidebar_logo">
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <path
                                d="M1.90488 42.0529C0.417595 42.0529 0 41.2303 0 39.838C0 38.4456 0.417595 37.623 1.90488 37.623H3.73383V38.5093H2.468C1.45525 38.5093 1.1642 38.7623 1.1642 39.8384C1.1642 40.9144 1.45525 41.1675 2.468 41.1675H3.7971V42.0537H1.90488V42.0529Z"
                                fill="white"
                            />
                            <path
                                d="M11.2773 39.8388C11.2773 41.6867 10.6636 42.1043 8.9232 42.1043C7.18283 42.1043 6.56909 41.6867 6.56909 39.8388C6.56909 37.9908 7.18283 37.5732 8.9232 37.5732C10.6636 37.5732 11.2773 37.9972 11.2773 39.8388ZM8.9232 41.2185C9.84737 41.2185 10.1131 40.8831 10.1131 39.8388C10.1131 38.7944 9.84737 38.459 8.9232 38.459C7.99904 38.459 7.73329 38.7944 7.73329 39.8388C7.73329 40.8831 7.99904 41.2185 8.9232 41.2185Z"
                                fill="white"
                            />
                            <path
                                d="M18.9789 41.3953C18.9789 41.699 18.8144 42.1039 18.169 42.1039C17.8653 42.1039 17.5616 42.0533 17.3275 41.699L15.5998 39.0981C15.5492 39.0222 15.5112 38.9905 15.4796 38.9905C15.4543 38.9905 15.4037 39.0032 15.4037 39.1171V42.0537H14.4415V38.2692C14.4415 37.7884 14.8085 37.5732 15.2767 37.5732C15.5931 37.5732 15.8968 37.6618 16.0929 37.9529L17.8333 40.5791C17.8649 40.6233 17.8902 40.6866 17.9472 40.6866C18.0168 40.6866 18.0168 40.6107 18.0168 40.5791V37.6235H18.9789V41.3953Z"
                                fill="white"
                            />
                            <path
                                d="M26.8072 41.3953C26.8072 41.699 26.6427 42.1039 25.9973 42.1039C25.6936 42.1039 25.3899 42.0533 25.1558 41.699L23.428 39.0981C23.3774 39.0222 23.3395 38.9905 23.3078 38.9905C23.2825 38.9905 23.2319 39.0032 23.2319 39.1171V42.0537H22.2698V38.2692C22.2698 37.7884 22.6368 37.5732 23.105 37.5732C23.4213 37.5732 23.725 37.6618 23.9216 37.9529L25.6619 40.5791C25.6936 40.6233 25.7189 40.6866 25.7758 40.6866C25.8454 40.6866 25.8454 40.6107 25.8454 40.5791V37.6235H26.8072V41.3953Z"
                                fill="white"
                            />
                            <path
                                d="M33.8126 38.4834H31.5344C31.313 38.4834 31.2371 38.5593 31.2371 38.7807V39.3945H33.7557V40.217H31.2371V40.894C31.2371 41.1155 31.313 41.1914 31.5344 41.1914H33.8379V42.0519H30.7685C30.3572 42.0519 30.0978 41.8494 30.0978 41.3749V38.3054C30.0978 37.8309 30.3572 37.6221 30.7685 37.6221H33.8126V38.483V38.4834Z"
                                fill="white"
                            />
                            <path
                                d="M38.78 42.0529C37.2927 42.0529 36.8751 41.2303 36.8751 39.838C36.8751 38.4456 37.2927 37.623 38.78 37.623H40.609V38.5093H39.3431C38.3304 38.5093 38.0393 38.7623 38.0393 39.8384C38.0393 40.9144 38.3304 41.1675 39.3431 41.1675H40.6722V42.0537H38.78V42.0529Z"
                                fill="white"
                            />
                            <path
                                d="M45.1843 42.0533V38.5092H43.5388V37.623H47.9686V38.5092H46.3232V42.0533H45.1839H45.1843Z"
                                fill="white"
                            />
                            <path
                                d="M0.09729 6V33.8649H18.5929V27.9684H6.35725V22.7999H18.5929V16.9041H6.35725V11.8965H18.5929V6H0.09729Z"
                                fill="white"
                            />
                            <path d="M29.3115 24.0668V33.8661H22.1436V16.9072L29.3115 24.0668Z" fill="white" />
                            <path
                                d="M40.832 6V19.8016L27.0771 6.04666H22.009V11.1155L40.832 29.9393V33.8649H47.9999V6H40.832Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                    <ul>
                        {Object.entries(sidenavIcons).map(([key, value], index) => (
                            <li
                                style={{
                                    cursor: 'pointer',
                                }}
                                key={index}
                                onClick={() => this.handleMenuIconActiveStatus(index)}
                                className={`sidebar_icon ${index === setMenuActiveStatus ? 'active' : ''}`}
                            >
                                {index === setMenuActiveStatus ? value.filled : value.default}
                            </li>
                        ))}
                    </ul>
                    <div style={{ marginTop: 'auto' }}>
                        <div
                            className={`profile_img ${showProfilePageNew ? 'active' : ''}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                this.props.wallpaperPreviewSection(false);
                                this.setState(
                                    {
                                        showProfilePageNew: true,
                                        setMenuActiveStatus: null,
                                        selectedMenuName: 'Profile',
                                        newGroupParticipants: false,
                                        archivedChatList: false,
                                    },
                                    () => {
                                        Store.dispatch(UpdateArchiveChatDataAction({ isArchived: false }));
                                    },
                                );
                            }}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    this.setState({
                                        showProfilePageNew: true,
                                        setMenuActiveStatus: null,
                                        selectedMenuName: 'Profile',
                                    });
                                }
                            }}
                        >
                            <ProfileImage
                                chatType={'chat'}
                                imageToken={vCardData?.data?.thumbImage || vCardData?.data?.image || ''}
                                temporary={true}
                                name={vCardData?.data?.nickName || ''}
                                hideClassNameStatus={true}
                            />
                            <WebChatVCard showProfilePageNew={showProfilePageNew} />
                        </div>
                    </div>
                </nav>
                <div className="recent-chatlist">
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        {newChatStatus &&
                            !channelsStatus &&
                            !invitationsStatus &&
                            !callLogs &&
                            !archivedChatList &&
                            !settingStatus && (
                                <>
                                    <div className="recent-chatlist-header">
                                        <h3 className="ting_tittle">{selectedMenuName}</h3>
                                        <div className="profile-options">
                                            <i
                                                className="newchat-icon sidebar_newchat_icon"
                                                onClick={this.handleNewChat}
                                                title="New chat"
                                            >
                                                <span className="toggleAnimation"></span>
                                                {/* <MessageSquarePlus /> */}
                                                <NewChat />
                                            </i>
                                            <i
                                                className={menuDropDownStatus ? 'menu-icon open' : 'menu-icon'}
                                                onClick={this.handleMenuDrop}
                                                onKeyDown={e =>
                                                    (e.key === 'Enter' || e.key === ' ') && this.handleMenuDrop(e)
                                                }
                                                role="button"
                                                tabIndex={0}
                                                title="More options"
                                            >
                                                <span className="toggleAnimation"></span>
                                                <DotMenu />
                                            </i>
                                        </div>
                                        {menuDropDownStatus ? (
                                            <ul className="menu-dropdown open" ref={this.menuRef}>
                                                {isGroupChatEnabled && (
                                                    <li
                                                        title="New Group"
                                                        onClick={() => {
                                                            this.handleCreateNewGroup();
                                                            this.setState({ menuDropDownStatus: false });
                                                        }}
                                                        role="button"
                                                        tabIndex={0}
                                                        onKeyDown={e =>
                                                            (e.key === 'Enter' || e.key === ' ') &&
                                                            this.handleCreateNewGroup()
                                                        }
                                                    >
                                                        <i>
                                                            <NewGroup />
                                                        </i>
                                                        <span>New Group</span>
                                                    </li>
                                                )}

                                                <li
                                                    title="Archived Chats"
                                                    onClick={() => {
                                                        this.handleArchivedChatList();
                                                        this.setState({ menuDropDownStatus: false });
                                                    }}
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={e =>
                                                        (e.key === 'Enter' || e.key === ' ') &&
                                                        this.handleArchivedChatList()
                                                    }
                                                >
                                                    <i>
                                                        <Archived />
                                                    </i>
                                                    <span>Archived</span>
                                                </li>

                                                <li
                                                    title="Logout"
                                                    className="webchat-logout"
                                                    onClick={() => {
                                                        this.handleLogutStatus(true);
                                                    }}
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={e =>
                                                        (e.key === 'Enter' || e.key === ' ') &&
                                                        this.handleLogutStatus(true)
                                                    }
                                                >
                                                    <i>
                                                        <Logout />
                                                    </i>
                                                    <span>Logout</span>
                                                </li>
                                            </ul>
                                        ) : null}
                                    </div>
                                    {this.renderRecentChat('recent')}
                                </>
                            )}

                        {callLogs && (
                            <WebChatCallLogs
                                handleBackStatus={this.handleBackFromCallLogs}
                                handleShowCallScreen={this.props.handleShowCallScreen}
                                handleContactPermissionPopup={this.props.handleContactPermissionPopup}
                            />
                        )}

                        {archivedChatList && (
                            <div className="contactlist">
                                <div className="recent-chatlist-header">
                                    <div className="profile-img-name">
                                        <i
                                            className="newchat-icon"
                                            onClick={this.handleBackToRecentChat}
                                            onKeyDown={e =>
                                                (e.key === 'Enter' || e.key === ' ') && this.handleBackToRecentChat()
                                            }
                                            role="button"
                                            tabIndex={0}
                                            title="Back"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <ArrowBack />
                                        </i>
                                        <span className="explorechannel-text">{'Archived Chats'}</span>
                                    </div>
                                </div>
                                {this.renderRecentChat('archive')}
                            </div>
                        )}

                        {settingStatus && (
                            <Setting
                                handleBackFromSetting={this.handleBackFromSetting}
                                logoutStatus={this.handleLogutStatus}
                                featureStateData={featureStateData}
                                handleShowCallScreen={this.props.handleShowCallScreen}
                            />
                        )}

                        {channelsStatus && <Channels handleChannelsClick={this.handleChannelsClick} />}
                        {invitationsStatus && (
                            <>
                                <div className="recent-chatlist-header">
                                    <div className="profile-img-name">
                                        <i
                                            className="newchat-icon-channel"
                                            title="Back"
                                            onClick={this.handleBackToRecentChatFromInvite}
                                        >
                                            <ClosePopup style={{ fill: '#005386' }} />
                                        </i>
                                        <span>{'Channel requests'}</span>
                                    </div>
                                </div>
                                <Invitiations handleChannelsClick={this.handleChannelsClick} />
                            </>
                        )}

                        {!newChatStatus &&
                            !channelsStatus &&
                            !invitationsStatus &&
                            !callLogs &&
                            !archivedChatList &&
                            !settingStatus && (
                                <WebChatRoster newChatStatus={newChatStatus} handleBackStatus={this.handleBackStatus} />
                            )}
                        {popupStatus && (
                            <WebChatPopup history={this.props.history} logoutStatus={this.handleLogutStatus} />
                        )}
                    </div>
                    {/* </OutsideClickHandler> */}
                    {newGroupParticipants && (
                        <CreateNewGroup
                            vCardData={vCardData}
                            handleBackToRecentChat={this.handleBackToRecentChat}
                            newCall={this.state.newCall}
                            newCallType={this.state.newCallType}
                            handleBackFromNewCall={this.handleBackFromNewCall}
                            handleMakeNewCall={this.handleMakeNewCall}
                        />
                    )}
                </div>
                {open && modelType === 'action' && <ActionPopUp {...this.props.popUpData} />}
                {open && modelType === 'participants' && <ParticipantPopUp />}
                {open && ['callparticipants', 'inviteParticipants', 'calllogparticipants'].indexOf(modelType) > -1 && (
                    <CallParticipantsPopup />
                )}
                {open && ['mediaPermissionDenied', 'mediaAccessError'].indexOf(modelType) > -1 && <MediaErrorPopup />}
                {callConversionData.status && (
                    <CallConversionPopup
                        callConversionData={callConversionData}
                        resetCallConversionRequestData={this.resetCallConversionRequestData}
                        currentUserRequestingCallSwitch={this.currentUserRequestingCallSwitch}
                        remoteUserRequestingCallSwitch={this.remoteUserRequestingCallSwitch}
                    />
                )}
                {open && modelType === 'CallConfirm' && (
                    <Modal containerId="container">
                        <ActionPopup
                            handleActionText={'Ok'}
                            handleCancelText={'Cancel'}
                            handleAction={() => this.handleJoinCallAction()}
                            handleCancel={() => this.handleCancel()}
                            text={'Do you want to leave your call to join this one?'}
                        />
                    </Modal>
                )}
                {open && modelType === 'scheduleMeeting' && (
                    <CallScheduling
                        open={open}
                        handleMeetMsgeSend={this.handleMeetMsgeSend}
                        handleShowCallScreen={this.props.handleShowCallScreen}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        featureStateData: state.featureStateData,
        popUpData: state.popUpData,
        vCardData: state.vCardData,
        callLogData: state.callLogData,
        callConversionData: state.callConversionData,
        browserNotifyData: state.browserNotifyData,
        isEnableArchived: state?.webLocalStorageSetting?.isEnableArchived,
        contactPermission: state?.contactPermission?.data,
    };
};

const mapDispatchToProps = {
    resetWallpaperColor,
    wallpaperPreviewSection,
    requestCall,
};

function StandaloneProfileImage() {
    const vCardData = useSelector(state => state.vCardData);
    const thumbImage = vCardData.data.thumbImage;
    const nickName = vCardData.data.nickName;
    const image = vCardData.data.image;

    return (
        <ProfileImage
            chatType={'chat'}
            imageToken={thumbImage && thumbImage !== '' ? thumbImage : image}
            temporary={true}
            name={nickName}
            hideClassNameStatus={true}
            classProps={{ 'side-nav-profile-image': true }}
        />
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);

Sidebar.propTypes = {
    resetWallpaperColor: PropTypes.func,
    wallpaperPreviewSection: PropTypes.func,
    requestCall: PropTypes.func,
};
